import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';

import Home from '../pages/public/Home';
import AboutUs from '../pages/public/AboutUs';
import EvidenceResults from '../pages/public/EvidenceResults';
import NewsEvents from '../pages/public/NewsEvents';
import Login from '../pages/public/Login';
import Register from '../pages/public/Register';
import Remember from '../pages/public/Remember';

import ControlQuestions from '../pages/private/ControlQuestions';
import ControlStudents from '../pages/private/ControlStudent';
import ManageUsers from '../pages/private/ManageUsers';
import Profile from '../pages/private/Profile';
import Test from '../pages/private/Test';
import Course from '../pages/private/Course';
import AvailableCourses from '../pages/private/AvailableCourses';
import StudentCourseStudy from '../pages/private/StudentCourseStudy';
import StudentCourseCertificate from '../pages/private/StudentCourseCertificate';
import Evidencias from '../pages/private/Evidencias';
import EvidenciaFormPage from '../pages/private/EvidenciaFormPage';
import NoticiasEventos from '../pages/private/NoticiasEventos';
import NoticiasEventosFormPage from '../pages/private/NoticiasEventosFormPage';

import PrivateRoute from './PrivateRoute';
import { ROLES } from '../utils/authUser';

const ADMIN_ONLY = [ROLES.ADMIN];
const ESTUDIANTE_ONLY = [ROLES.ESTUDIANTE];

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Rutas Públicas */}
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
		<Route path="/home" element={<MainLayout><Home /></MainLayout>} />
		<Route path="/about-us" element={<MainLayout><AboutUs /></MainLayout>} />
		<Route path="/evidence-results" element={<MainLayout><EvidenceResults /></MainLayout>} />
		<Route path="/news-events" element={<MainLayout><NewsEvents /></MainLayout>} />
        <Route path="/login" element={<Login />} />
		<Route path="/register" element={<Register />} />
		<Route path="/remember" element={<Remember />} />

        {/* Rutas Privadas */}
		<Route path="/control-questions" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><ControlQuestions/></PrivateRoute>}/>
		<Route path="/control-students" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><ControlStudents/></PrivateRoute>}/>
		<Route path="/manage-users" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><ManageUsers/></PrivateRoute>}/>
		<Route path="/profile" element={<PrivateRoute><Profile/></PrivateRoute>}/>
        <Route path="/test" element={<PrivateRoute><Test/></PrivateRoute>}/>
		<Route path="/course" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><Course/></PrivateRoute>}/>
		<Route path="/available-courses" element={<PrivateRoute allowedRoles={ESTUDIANTE_ONLY}><AvailableCourses/></PrivateRoute>}/>
		<Route path="/curso/:idCurso" element={<PrivateRoute allowedRoles={ESTUDIANTE_ONLY}><StudentCourseStudy/></PrivateRoute>}/>
		<Route path="/curso/:idCurso/certificado" element={<PrivateRoute allowedRoles={ESTUDIANTE_ONLY}><StudentCourseCertificate/></PrivateRoute>}/>
		<Route path="/evidencias" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><Evidencias/></PrivateRoute>}/>
		<Route path="/evidencias/nueva" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><EvidenciaFormPage/></PrivateRoute>}/>
		<Route path="/evidencias/editar/:id" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><EvidenciaFormPage/></PrivateRoute>}/>
		<Route path="/noticias-eventos" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><NoticiasEventos/></PrivateRoute>}/>
		<Route path="/noticias-eventos/nueva" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><NoticiasEventosFormPage/></PrivateRoute>}/>
		<Route path="/noticias-eventos/editar/:id" element={<PrivateRoute allowedRoles={ADMIN_ONLY}><NoticiasEventosFormPage/></PrivateRoute>}/>
		<Route path="/add-evidence" element={<Navigate to="/evidencias" replace />}/>
      </Routes>
    </Router>
  );
};

export default AppRouter;